var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 10.1667C11.8087 10.1666 11.9483 10.1303 12.0723 10.0611C12.1963 9.99188 12.3005 9.89216 12.3752 9.77136C12.4498 9.65056 12.4923 9.5127 12.4987 9.37085C12.5051 9.229 12.4751 9.08787 12.4117 8.96085L10.9317 6.00002L12.4117 3.03919C12.4751 2.91217 12.5051 2.77104 12.4987 2.62919C12.4923 2.48734 12.4498 2.34948 12.3752 2.22868C12.3005 2.10789 12.1963 2.00816 12.0723 1.93897C11.9483 1.86979 11.8087 1.83343 11.6667 1.83335H2.49999V1.00002C2.49999 0.779007 2.4122 0.567045 2.25592 0.410765C2.09964 0.254484 1.88768 0.166687 1.66666 0.166687C1.44565 0.166687 1.23369 0.254484 1.07741 0.410765C0.921126 0.567045 0.833328 0.779007 0.833328 1.00002V16C0.833328 16.221 0.921126 16.433 1.07741 16.5893C1.23369 16.7456 1.44565 16.8334 1.66666 16.8334C1.88768 16.8334 2.09964 16.7456 2.25592 16.5893C2.4122 16.433 2.49999 16.221 2.49999 16V10.1667H11.6667Z",
    fill: "#F43F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFlag);
export default __webpack_public_path__ + "static/media/red-flag.9d9c55f54a375084b9ff4635106d8f5d.svg";
export { ForwardRef as ReactComponent };